import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { P500UIBaseModal } from '@platform500services/p500-ui-kit';
import { GroupRelation } from '../../services/responses/settings.response';

@Component({
  selector: 'gtd-relation-modal',
  templateUrl: './relation-modal.component.html',
})
export class RelationModalComponent extends P500UIBaseModal implements OnInit {
  @HostBinding('class') className = 'c-modal c-modal--d c-modal--action-form -primary -small';
  public form: any = new UntypedFormGroup({});
  public filterMap = new Map<
    string,
    {
      label: string;
      values: Record<string, string>;
    }
  >();
  @Input() public value: unknown;
  @Input() public data: GroupRelation;
  @Input() public cb: (v: any) => void = () => {};

  public ngOnInit(): void {
    for (const item of this.data.relations) {
      const filters = new UntypedFormGroup({});
      for (const { key, label, values } of item.filters) {
        filters.addControl(key, new UntypedFormControl([]));
        switch (key) {
          case 'question_id':
            {
              const qSelect = Object.entries(values).reduce((acc, [qKey, qValue]) => {
                try {
                  acc[qKey] = `${JSON.parse(qValue).question} / ${qKey}`;
                } catch {}
                return acc;
              }, {});
              this.filterMap.set(key, {
                label,
                values: qSelect,
              });
            }
            break;
          default:
            this.filterMap.set(key, {
              label,
              values,
            });
            break;
        }
      }
      this.form.addControl(
        item.key,
        new UntypedFormGroup({
          values: new UntypedFormControl([]),
          filters,
        })
      );
    }
    this.form.patchValue(this.value);
  }

  public submit(): void {
    this.cb(this.form.getRawValue());
  }

  public reset() {
    this.cb({});
  }
}
